import { GeneralService } from 'src/app/services/general.service';
import { NotificationService } from './../../../services/notification.service';
import { FormularioService } from './../../../services/formulario.service';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { AbstractControl, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { GeneralComponent } from 'src/app/shared/general.component';


@Component({
    // tslint:disable-next-line: component-selector
    selector: 'app-rs009-card-II',
    templateUrl: './rs009-card-II.component.html'
})

export class Rs009CardIIComponent extends GeneralComponent implements OnInit {
    public formulario?: FormGroup;

    @Output() objMakeCalculations = new EventEmitter();
    @Output() objMakeCalculationsPreBasica = new EventEmitter();

    // tslint:disable-next-line: max-line-length
    constructor(protected formularioService: FormularioService, protected formBuilder: FormBuilder, protected notificationService: NotificationService, protected generalService: GeneralService) {
        super('Etapa 2', false);

        // Formulario v1.1...


        if (this.isComercial || this.isBasica) {
            this.formulario = this.formBuilder.group({
                Graos_Ardidos: [null, [Validators.max(20000)]],
                Esclerocitos: [null, [Validators.max(20000)]],
                Sabugo: [null, [Validators.max(20000)]],
                Graos_Carunchados: [null, [Validators.max(20000)]],
                Sementes_Quebradas: [null, [Validators.max(20000)]],
                Out_Cultivares: [null, [Validators.max(20000)]],
                Umidade_Direcionamento: [null, []],
                //Umidade: [null, []],
                Observacao: [null, []]
            });
            this.formulario.get('Sabugo')['warning'] = false;
        }
        else {
            this.formulario = this.formBuilder.group({
                peso_amostra: [null, [Validators.required]],
                peso_liquido: [null, [Validators.required]],
                palha: [null, [Validators.required]],
                impurezas: [null, [Validators.required]],
                peso_sementes: [null, [Validators.required]],
                peso_material: [null, [Validators.required]],
                sabugo_milho: [null, [Validators.required]],
                espigas_atipicas: [null, []],
                descarte_mesa: [null, []],
                observacao_amostra: [null, [Validators.required]]
            });
        }
    }

    async ngOnInit(): Promise<void> {
    }

    changeCollapse(): void {
        this.collapseCard = this.collapseCard ? false : true;
    }

    hasErrorFormControl(campoFormulario?: AbstractControl): string {
        return this.formularioService.hasErrorFormControl(campoFormulario);
    }

    public async makeCalculations(): Promise<void> {
        this.objMakeCalculations.emit();
    }

    public makeCalculationsPreBasica($event){
        this.objMakeCalculationsPreBasica.emit();
    }

    public async getQtdeSabugoMi(): Promise<void> {
        await this.makeCalculations();
    }

    customUmidadeValidator(control) {
        const umidade = control.value;
        const parsedValue = parseFloat(umidade.replace(',', '.').replace('%', ''));

        if (isNaN(parsedValue)) {
            return { invalidUmidade: true };
        }

        if (parsedValue < 5 || parsedValue > 40) {
            return { invalidUmidadeRange: true };
        }

        return null; // A validação passou
    }

}

